exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editor[data-v-f8bfd85e]{\r\n    padding: 20px;\r\n    border-left-width: 5px;\r\n    border-left-color: #333\n}\ntextarea[data-v-f8bfd85e]{\r\n    width: 100%;\r\n    min-height: 200px;\r\n    font-size: 11pt;\r\n    border: none;\r\n  border-right: 1px solid #ccc;\r\n  resize: none;\r\n  outline: none;\r\n  background-color: #f6f6f6;\r\n  font-size: 14px;\r\n  font-family: 'Monaco', courier, monospace;\r\n  padding: 20px;\n}\n.clickable[data-v-f8bfd85e] {\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
